import { ref } from 'vue';
import {
  countryCodeIsSingapore,
  countryCodeIsVietnam,
  peekCachedCurrentIpCountryCode,
  resolveCountryCodeFromCurrentIp,
} from '@/utils/ip-country-lookup';

/**
 * 落地「现金扫码」仅当前出口 IP 为 VN 或 SG 时展示。
 * 新加坡复用现有越南 TopPay 落地通道；不会将 SG 伪装成独立 SGD 区域。
 * 资料国家码不参与；探测失败 fail-closed（不展示）。
 */
export const VIETNAM_PAY_IP_GUARD_ENABLED = true;

function isVietnamPayLandingIp(countryCode) {
  return countryCodeIsVietnam(countryCode) || countryCodeIsSingapore(countryCode);
}

export const vietnamPayIpAllowed = ref(
  !VIETNAM_PAY_IP_GUARD_ENABLED || isVietnamPayLandingIp(peekCachedCurrentIpCountryCode())
);

export function resetVietnamPayIpAllowed() {
  vietnamPayIpAllowed.value = !VIETNAM_PAY_IP_GUARD_ENABLED;
}

/**
 * 仅看当前出口网络。打开弹窗时跟在美国 IP 探测之后调用即可复用缓存。
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
export async function resolveIsVietnamPayIpAllowed({ forceRefresh = false } = {}) {
  if (!VIETNAM_PAY_IP_GUARD_ENABLED) {
    vietnamPayIpAllowed.value = true;
    return true;
  }
  const countryCode = await resolveCountryCodeFromCurrentIp({ forceRefresh }).catch(() => null);
  const allowed = isVietnamPayLandingIp(countryCode);
  vietnamPayIpAllowed.value = allowed;
  return allowed;
}
